import React from 'react';
import { Network, Target, Users, Briefcase, TrendingUp, ShieldCheck, Globe, Zap } from 'lucide-react';
export function AboutPage() {
  const pillars = [{
    icon: Network,
    title: 'Access to Networks',
    desc: 'Curated introductions to strategic partners, potential customers, and industry leaders.'
  }, {
    icon: Target,
    title: 'Tailored Advisory',
    desc: '1-on-1 support for product development, commercialization, and investment readiness.'
  }, {
    icon: Users,
    title: 'Founder-Centered',
    desc: 'Inspiration and peer learning through the exclusive Black Founders Network community.'
  }];
  const hubs = [{
    icon: Briefcase,
    title: 'Strategic Advisory',
    desc: 'Expert guidance on scaling operations and business models.'
  }, {
    icon: TrendingUp,
    title: 'Fundraising Guidance',
    desc: 'Pitch prep, financial modeling, and investor readiness.'
  }, {
    icon: Network,
    title: 'Partner Introductions',
    desc: 'Direct connections to enterprise and corporate partners.'
  }, {
    icon: Users,
    title: 'Leadership Development',
    desc: 'Executive coaching and peer-to-peer learning circles.'
  }, {
    icon: ShieldCheck,
    title: 'Operational Support',
    desc: 'Infrastructure, legal, and HR foundational support.'
  }, {
    icon: Globe,
    title: 'Market Access',
    desc: 'Go-to-market strategies for new verticals and geographies.'
  }];
  return <div className="space-y-12 animate-in fade-in duration-500 pb-12" data-id="element-84">
      {/* Hero Section */}
      <div className="relative rounded-3xl overflow-hidden shadow-xl h-[400px]" data-id="element-85">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/euSbQ78H16trbxo1wgCCeA/Screenshot_2026-03-20_at_2.29.47_PM.png)'
      }} data-id="element-86"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-catalyst-black via-catalyst-black/80 to-transparent" data-id="element-87"></div>

        <div className="relative h-full flex flex-col justify-center px-12 max-w-3xl" data-id="element-88">
          <span className="inline-block px-3 py-1 bg-catalyst-mustard/20 text-catalyst-mustard font-semibold text-sm rounded-full mb-4 border border-catalyst-mustard/30 w-fit" data-id="element-89">
            The BFN Scale Program
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight mb-4" data-id="element-90">
            Scale with intention.
            <br data-id="element-91" />
            Build with access.
          </h1>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-92">
            A six-month growth program supported by the Black Opportunity Fund,
            designed to support revenue-generating, Black-led businesses ready
            to scale sustainably.
          </p>
        </div>
      </div>

      {/* About Section */}
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-93">
        <h2 className="text-3xl font-bold text-catalyst-black" data-id="element-94">
          About the Program
        </h2>
        <div className="w-20 h-1 bg-catalyst-mustard mx-auto rounded-full" data-id="element-95"></div>
        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-96">
          The Black Founders Network is an inclusive community that supports
          Black founders at all stages of their entrepreneurial journey. The
          Catalyst platform serves as the digital home for our flagship Scale
          Program, providing a centralized hub for learning, advisory, and
          community engagement.
        </p>
      </div>

      {/* Core Pillars */}
      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-12" data-id="element-97">
        <div className="text-center mb-10" data-id="element-98">
          <h2 className="text-2xl font-bold text-catalyst-black mb-2" data-id="element-99">
            Core Program Pillars
          </h2>
          <p className="text-gray-500" data-id="element-100">
            The foundation of the Catalyst experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-101">
          {pillars.map((pillar, idx) => {
          const Icon = pillar.icon;
          return <div key={idx} className="text-center group" data-id="element-102">
                <div className="w-16 h-16 mx-auto bg-catalyst-cream rounded-2xl flex items-center justify-center mb-6 group-hover:bg-catalyst-mustard group-hover:text-catalyst-black transition-all duration-300 shadow-sm border border-gray-100 group-hover:border-transparent" data-id="element-103">
                  <Icon size={32} className="text-catalyst-brown-dark group-hover:text-catalyst-black" data-id="element-104" />
                </div>
                <h3 className="text-xl font-bold text-catalyst-black mb-3" data-id="element-105">
                  {pillar.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-106">{pillar.desc}</p>
              </div>;
        })}
        </div>
      </div>

      {/* Hubs Section */}
      <div data-id="element-107">
        <div className="flex items-center gap-4 mb-8" data-id="element-108">
          <h2 className="text-2xl font-bold text-catalyst-black" data-id="element-109">
            Support Hubs
          </h2>
          <div className="h-px bg-gray-200 flex-1" data-id="element-110"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-111">
          {hubs.map((hub, idx) => {
          const Icon = hub.icon;
          return <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:border-catalyst-mustard/50 hover:shadow-md transition-all group" data-id="element-112">
                <div className="flex items-center gap-4 mb-4" data-id="element-113">
                  <div className="p-3 bg-gray-50 rounded-xl group-hover:bg-catalyst-mustard/10 transition-colors" data-id="element-114">
                    <Icon size={24} className="text-catalyst-black group-hover:text-catalyst-mustard-dark" data-id="element-115" />
                  </div>
                  <h3 className="text-lg font-bold text-catalyst-black" data-id="element-116">
                    {hub.title}
                  </h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-117">
                  {hub.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </div>;
}